import { Badge } from "@/components/ui/badge";

interface OnboardingMessagesToolbarProps {
  messagesCount: number;
  title: string;
  desc: string;
}

export function OnboardingMessagesToolbar({
  messagesCount,
  title,
  desc
}: OnboardingMessagesToolbarProps) {
  return (
    <div className="mb-4">
      <div className="mb-1 flex items-center justify-between">
        <h3 className="text-lg font-semibold">{title}</h3>
        <Badge variant="secondary" className="text-xs">
          {messagesCount} messages
        </Badge>
      </div>
      <p className="text-sm text-muted-foreground">
        {desc}
      </p>
    </div>
  );
}
